<template>
  <div class="loading-wrap">
    <div class="loading">
      <img src="@img/icon_loading_2.png" class="loading-icon" :alt="loadingAlt" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {}
  },
  computed: {
    ...mapState({
      gameId: (state) => state.app.gameId,
      seoLang: (state) => state.app.seoLang,
    }),
    loadingAlt() {
      const keys = this.seoLang.loading || []
      try {
        return keys
          .map((key) => (this.$te(key) && this.$t(key)) || '')
          .filter((msg) => !!msg)
          .join(', ')
      } catch (error) {
        return ''
      }
    },
  },
}
</script>
<style lang="less" scoped>
.loading-wrap {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0);
  z-index: 10000;
  .loading {
    width: 60px;
    height: 60px;
    display: block;
    padding: 12.5px;
    margin: 40px auto;
    background-color: #343a3f;
    border-radius: 18px;
  }
  .loading-icon {
    width: 100%;
    height: 100%;
    animation: loading-rotate 2s linear infinite;
  }
}
@keyframes loading-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
